import Vue from 'vue'
import {
  Button,
  ButtonGroup,
  Table,
  TableColumn
} from 'element-ui'

Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)


// WEBPACK FOOTER //
// ./src/assets/js/element-ui.js